<template>
  <v-container class="py-10">
    <broadcast-carousel
      v-for="(config, index) in dashboardConfig"
      :key="index"
      :apiEndpoint="config.apiEndpoint"
      :categoryId="config.categoryId"
      :name="config.name"
      :categorySeoName="config.seoName"
    ></broadcast-carousel>
  </v-container>
</template>

<script>
import { mapActions, mapState } from 'vuex';
export default {
  data: () => ({}),
  computed: {
    ...mapState([
      'dashboardConfig',
    ]),
  },
  methods: {
    ...mapActions([
      'getDashboardConfig',
    ]),
    broadcastsByStatus(status) {
      if (this.broadcasts) {
        return this.broadcasts.filter(broadcast => {
          return broadcast.status === status;
        });
      }
      return false;
    },
  },
  created() {
    this.getDashboardConfig();
  }
};
</script>
<style scoped>
.banner {
  width: 100%;
  max-width: 1800px;
}
</style>
